import { PIEVE_MODEL_MAP, PIEVE_SENTINEL_MODELS } from './modelCatalog.js';

export const normalizePieveModelId = (modelId) => {
  const normalizedModelId = String(modelId ?? '').trim();

  if (!normalizedModelId) {
    return null;
  }

  const sentinelKey = normalizedModelId.toUpperCase().replace(/-/g, '_');

  if (PIEVE_SENTINEL_MODELS[sentinelKey]) {
    return sentinelKey;
  }

  const lowerModelId = normalizedModelId.toLowerCase();

  if (PIEVE_MODEL_MAP[lowerModelId]) {
    return lowerModelId;
  }

  return normalizedModelId;
};

export const isPieveSelectableModelId = (modelId) => {
  const normalizedModelId = normalizePieveModelId(modelId);

  return Boolean(PIEVE_SENTINEL_MODELS[normalizedModelId]) || Boolean(PIEVE_MODEL_MAP[normalizedModelId]);
};

export const resolvePieveModelId = (modelId) => {
  const normalizedModelId = normalizePieveModelId(modelId);

  return PIEVE_SENTINEL_MODELS[normalizedModelId]?.targetModelId ?? normalizedModelId;
};
